/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Error_Quota_ExceededInputs */



/**
* | output |
* | --- |
* | "Your usage quota is exhausted. Upgrade your plan or adjust your spending limit to continue." |
*
* @param {Chat_Error_Quota_ExceededInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_error_quota_exceeded = /** @type {((inputs?: Chat_Error_Quota_ExceededInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_Quota_ExceededInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dein Nutzungskontingent ist aufgebraucht. Passe dein Ausgabenlimit an oder upgrade deinen Plan, um fortzufahren.")
	return /** @type {LocalizedString} */ ("Your usage quota is exhausted. Upgrade your plan or adjust your spending limit to continue.")
});